import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.667 1.332a.667.667 0 0 1 .662.589l.004.078v.666H12a2 2 0 0 1 1.997 1.883l.003.117v8a2 2 0 0 1-1.883 1.997l-.117.003H4a2 2 0 0 1-1.997-1.882L2 12.665v-8A2 2 0 0 1 3.883 2.67L4 2.665h.667V2a.667.667 0 0 1 1.328-.078L6 1.999v.666h4V2a.666.666 0 0 1 .667-.667m2 4.667H3.333v6.416c0 .47.258.858.589.911l.078.006h8c.342 0 .624-.353.662-.81l.005-.107z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 8a.667.667 0 0 1 .662.589l.005.078v2a.667.667 0 0 1-1.329.078l-.005-.078V9.333a.667.667 0 0 1-.078-1.328L7.333 8z",
      style: {"fill-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }